<template>
    <custom-checkbox
        :data-meta-id="metadata.id"
        :input-id="metadata.name"
        :value="value"
        :required="required"
        :label="getLabel"
        @update:value="emitValue" />
</template>

<script>
import { mapGetters } from 'vuex';
import CustomCheckbox from '@/components/metadata/inputs/checkbox/CustomCheckbox.vue';

export default {
    components: {
        CustomCheckbox
    },
    props: {
        metadata: { type: Object, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        getLabel() {
            return this.metadata['description' + this.upperLocale];
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
